import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import { theme } from '../utils';
import { useDispatch, useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import { logout } from '../store/actions/sessionActions';

const DefaultLayout = React.lazy(() => import('./layouts/DefaultLayout'));
const NotLoggedLayout = React.lazy(() => import('./layouts/NotLoggedLayout'));

const Navigator = () => {
  const { token, isLogged } = useSelector((state) => state.session);
  const dispatch = useDispatch();

  useEffect(() => {
    try {
      const decodedToken = jwtDecode(token);
      const expirationDate = decodedToken.exp * 1000;
      if (Date.now() >= expirationDate) dispatch(logout())
    } catch (error) {
      dispatch(logout())
      console.error("Token inválido o error al decodificar:", error);
    }
  }, [])

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        {
          isLogged ? <DefaultLayout /> : <NotLoggedLayout />
        }
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default Navigator;
